import type { ChangeEvent, CSSProperties, FC } from 'react';
import { Input, Select } from 'antd';

import { Row } from '@/shared/components/layout';
import { PhoneCodesList } from '@/shared/constants/countries-list';

type InputPhonerNumber = {
  placeholder: string;
  codes?: Array<string>;
  style?: CSSProperties;
  className?: string;
  value?: { phoneNumber?: string; phoneCode?: string };
  setPhoneNumber: (value: string) => void;
  setPhoneCode: (value: string) => void;
};

export const InputPhoneNumber: FC<InputPhonerNumber> = ({
  placeholder,
  style,
  value,
  setPhoneNumber,
  setPhoneCode,
  ...props
}) => {
  const onChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setPhoneNumber(e.target.value);
  };

  const handleChange = (val: string) => {
    setPhoneCode(val);
  };

  return (
    <Row nowrap gapColumn={4} style={style} {...props}>
      <Select
        onChange={handleChange}
        placeholder={'+000'}
        options={PhoneCodesList}
        value={value?.phoneCode}
        popupMatchSelectWidth={false}
        // size="large"
      />
      <Input
        type="number"
        placeholder={placeholder}
        onChange={onChange}
        value={value?.phoneNumber}
      />
    </Row>
  );
};
